import constants from '../../constants';

const resetCommittees = () => dispatch => (
  dispatch({ type: constants.RESET_COMMITTEES })
);

export default resetCommittees;
